import { FC, ReactElement, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isTokenMinutesFromExpiring, setLastInteractionTimestamp } from 'app/api/cookie';
import { useExchangeToken } from 'app/api/hooks/core/v1/auth/user';
import { gaTrackPage } from 'app/services/google-analytics';
import { useAuthState } from 'app/state/AuthContext/hooks';
import { useGeneralDispatch, useGeneralState } from 'app/state/GeneralContext/hooks';
import { PropsWithOnlyChildren } from 'app/types';

import * as serviceWorker from '../../serviceWorker';

// Local Variables
function sendGoogleAnalyticsData(pathname: string, search: string) {
  gaTrackPage(pathname,
    search);
}
// Component Definition
const RouteListener: FC<PropsWithOnlyChildren> = ({ children }) => {
  const generalDispatch = useGeneralDispatch();

  const location = useLocation();

  const { tokenData } = useAuthState();

  const { isServiceWorkerUpdated } = useGeneralState();

  const { mutate: exchangeToken } = useExchangeToken();

  useEffect(() => {
    if (isServiceWorkerUpdated) {
      const { origin } = window.location;

      window.location.href = `${origin}${location.pathname}${location.search}`;
    }

    if (!!tokenData && isTokenMinutesFromExpiring()) {
      exchangeToken();
    }

    sendGoogleAnalyticsData(location.pathname,
      location.search);
    setLastInteractionTimestamp();
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [
    generalDispatch,
    isServiceWorkerUpdated,
    isTokenMinutesFromExpiring,
    location.pathname,
    location.search,
    sendGoogleAnalyticsData,
  ]);

  useEffect(() => {
    sendGoogleAnalyticsData(location.pathname,
      location.search);

    serviceWorker.register({
      onUpdate: () => {
        generalDispatch({
          type: 'updateServiceWorker',
        });
      },
    });

    return serviceWorker.unregister;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  return children as ReactElement;
};

export default RouteListener;
